import React from 'react'

export interface GaugeMeterProps {
    /** Avance entre 0 y 1; se recorta a ese rango. */
    value: number
    label: string
    caption?: string
}

const RADIUS = 80
const STROKE = 14
const ARC = Math.PI * RADIUS

const toneOf = (value: number) => {
    if (value >= 0.66) return 'rgb(var(--k-ok))'
    if (value >= 0.33) return '#FF7A3D'
    return 'rgb(var(--k-danger))'
}

/** Medidor semicircular de avance contra una meta. */
const GaugeMeter = ({ value, label, caption }: GaugeMeterProps) => {
    const clamped = Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0))
    const path = `M ${STROKE / 2} ${RADIUS + STROKE / 2} A ${RADIUS} ${RADIUS} 0 0 1 ${RADIUS * 2 + STROKE / 2} ${RADIUS + STROKE / 2}`

    return (
        <div className="flex flex-col items-center gap-1">
            <svg viewBox={`0 0 ${RADIUS * 2 + STROKE} ${RADIUS + STROKE}`} className="w-full max-w-[220px]" role="img" aria-label={`${label}: ${Math.round(clamped * 100)}%`}>
                <path d={path} fill="none" stroke="rgb(var(--k-line-soft))" strokeWidth={STROKE} strokeLinecap="round" />
                <path
                    d={path}
                    fill="none"
                    stroke={toneOf(clamped)}
                    strokeWidth={STROKE}
                    strokeLinecap="round"
                    strokeDasharray={`${ARC * clamped} ${ARC}`}
                    style={{ transition: 'stroke-dasharray 0.6s ease' }}
                />
            </svg>
            <span className="-mt-10 text-[22px] font-extrabold tabular-nums tracking-[-0.02em] text-k-ink">{label}</span>
            {caption && <span className="text-xs font-semibold text-k-muted">{caption}</span>}
        </div>
    )
}

export default GaugeMeter
